import React from 'react';
import { APP_VERSION } from '../version';

/**
 * Límite de error de nivel raíz: captura cualquier crash de render (p. ej. el
 * React #31 al recibir una respuesta inesperada) y muestra una pantalla de
 * recuperación en vez de una pantalla en blanco/azul. Sin dependencias.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Log local; aquí engancharía Sentry si se configura (ver INSTALACION-PROD.md).
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info?.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center', gap: 16, padding: 24,
        textAlign: 'center', fontFamily: 'system-ui, sans-serif',
      }}>
        <h1 style={{ fontSize: 20, margin: 0 }}>Algo salió mal</h1>
        <p style={{ opacity: 0.7, maxWidth: 420, margin: 0 }}>
          Ocurrió un error inesperado en la interfaz. Puedes recargar la página;
          tu trabajo guardado no se pierde.
        </p>
        <button
          onClick={() => window.location.reload()}
          style={{
            padding: '10px 20px', borderRadius: 8, border: 'none',
            background: '#2563eb', color: '#fff', cursor: 'pointer', fontSize: 14,
          }}
        >
          Recargar
        </button>
        <span style={{ fontSize: 11, opacity: 0.4 }}>v{APP_VERSION}</span>
      </div>
    );
  }
}

export default ErrorBoundary;
